// Always includes the first and last page, plus a window around the
// current page, with '...' marking any gap - e.g. for page 5 of 10:
// [1, '...', 4, 5, 6, '...', 10]
export function buildPagination(current: number, totalPages: number): (number | '...')[] {
    if(totalPages <= 0) {
        return [];
    }

    const pages = new Set<number>();
    pages.add(1);
    pages.add(totalPages);
    for(let p = current - 1; p <= current + 1; p++) {
        if(p >= 1 && p <= totalPages) {
            pages.add(p);
        }
    }

    const sorted = Array.from(pages).sort((a, b) => a - b);
    const result: (number | '...')[] = [];
    sorted.forEach((page, i) => {
        if(i > 0 && page - (sorted[i - 1] as number) > 1) {
            result.push('...');
        }
        result.push(page);
    });
    return result;
}

// For cursor-based pagination (e.g. HubSpot's "after" token APIs) where the
// total/last page is never knowable - still always shows page 1 so you can
// jump back to the start, but never fabricates a last page.
export function buildPaginationOpenEnded(current: number, hasNextPage: boolean): (number | '...')[] {
    const pages = new Set<number>();
    pages.add(1);
    pages.add(current);
    if(current > 1) {
        pages.add(current - 1);
    }
    if(hasNextPage) {
        pages.add(current + 1);
    }

    const sorted = Array.from(pages).sort((a, b) => a - b);
    const result: (number | '...')[] = [];
    sorted.forEach((page, i) => {
        if(i > 0 && page - (sorted[i - 1] as number) > 1) {
            result.push('...');
        }
        result.push(page);
    });
    return result;
}
